export default __webpack_public_path__ + "static/media/add-membros.05f97dea.svg";